<template lang="">
  <div class="cardContentT">
    <div
      class="flex"
      style="margin-top:5px;padding-left: 10px;box-sizing:border-border-box;"
    >
      <div
        class="choseType"
        :class="active === index ? 'select' : ''"
        v-for="(item, index) in navList"
        :key="index"
        @click="typeSelect(item, index)"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="chart">
      <loadEchart ref="echarts"></loadEchart>
    </div>
  </div>
</template>

<script>
// import { loadChart } from "../chart/qxChartData";
// import { getHasHistoryDevice, findWlwWeatherGetLSSJ } from "@/api/zhwl";
import { findRealData, findHistoryData } from "@/api/zhwl";
// import { deviceOption } from "@/util/deviceOption";
import * as echarts from "echarts";
export default {
  data() {
    return {
      active: 0,
      navList: [
        {
          name: "今天",
          day: 1,
        },
        {
          name: "最近三天",
          day: 3,
        },
        {
          name: "最近一周",
          day: 7,
        },
      ],
      equimentIds: [],
      equimentTimes: [],
      qxzList: [
        {
          name: "温度",
          value: "--",
          channel: "3",
          unit: "℃",
          img: require("images/index/zhwl/icon_wd.png"),
          top: "5%",
          type: "temp",
          indexs: [],
          echartsData: [],
        },
        {
          name: "湿度",
          value: "--",
          channel: "6",
          unit: "%",
          img: require("images/index/zhwl/icon_sd.png"),
          type: "humi",
          indexs: [],
          echartsData: [],
        },
        {
          name: "风向",
          value: "--",
          channel: "5",
          unit: "",
          img: require("images/index/zhwl/icon_fx.png"),
          top: "20%",
          type: "direction",
          indexs: [],
          echartsData: [],
        },
        {
          name: "风速",
          value: "--",
          channel: "5",
          unit: "m/s",
          img: require("images/index/zhwl/icon_fs.png"),
          top: "20%",
          type: "direction",
          indexs: [],
          echartsData: [],
        },
        {
          name: "气压",
          value: "--",
          channel: "5",
          unit: "m/s",
          img: require("images/index/zhwl/icon_qy.png"),
          top: "20%",
          type: "direction",
          indexs: [],
          echartsData: [],
        },
        {
          name: "雨量",
          value: "--",
          channel: "5",
          unit: "mm",
          img: require("images/index/zhwl/icon_yl.png"),
          top: "20%",
          type: "direction",
          indexs: [],
          echartsData: [],
        },
      ],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    typeSelect(item, index) {
      if (this.active == index) return;
      this.active = index;
      this.getHistoryData();
    },
    getData() {
      this.$refs.echarts.showLoading();
      // getWlwCode().then((res) => {
      let res = {
        data: window.deviceData,
      };
      if (res && res.data && res.data.weather)
        this.deviceCode = res.data.weather;
      else this.deviceCode = "CJGCA-000038";
      findRealData(this.deviceCode)
        .then((res) => {
          if (
            res.code == 200 &&
            res.data &&
            res.data.sensor &&
            res.data.sensor.length > 0
          ) {
            const sensor = res.data.sensor;
            this.qxzList.map((item) => {
              sensor.some((ele) => {
                if (ele.name.indexOf(item.name) > -1) {
                  this.equimentIds.push(ele.id);
                  item.id = ele.id;
                  item.name = ele.name;
                  item.unit = ele.sensor_type_unit || ele.unit || "";
                  item.value = ele.value || "";
                  item.channel = ele.channel;
                  item.echartsData = [];
                  item.indexs = [];
                  return true;
                }
              });
              return item;
            });
            console.log(
              "dsdsd",
              sensor,
              this.qxzList,
              this.equimentIds.length > 0
            );
            if (this.equimentIds.length > 0) this.getHistoryData();
          } else this.$refs.echarts.noOption();
        })
        .catch(() => {
          this.$refs.echarts.noOption();
        });
      // });
    },
    getHistoryData(
      ids = "equimentIds",
      type = "qxzList",
      timeType = "equimentTimes"
    ) {
      this.$refs.echarts.showLoading();
      let start_time = `${this.$formatDate(new Date(), "yyyy-MM-dd")} 00:00:00`;
      if (this.active == 0)
        start_time = this.$formatDate(
          new Date(new Date() - 1 * 24 * 3600 * 1000),
          "yyyy-MM-dd"
        );
      else if (this.active == 1)
        start_time = this.$formatDate(
          new Date(new Date() - 3 * 24 * 3600 * 1000),
          "yyyy-MM-dd"
        );
      else if (this.active == 2)
        start_time = this.$formatDate(
          new Date(new Date() - 7 * 24 * 3600 * 1000),
          "yyyy-MM-dd"
        );
      const end_time = this.$formatDate(new Date(), "yyyy-MM-dd hh:mm:ss");
      let group_type = this.active == 0 ? 5 : 4;
      const data = {
        sensor_ids: this[ids].join(","),
        group_type,
        start_time: this.$formatDate(start_time, "yyyy-MM-dd hh:mm:ss"),
        end_time,
      };
      console.log("里斯数据", data);
      findHistoryData(data)
        .then((res) => {
          if (
            res.code == 200 &&
            res.data &&
            res.data.sensor &&
            res.data.sensor.length > 0 &&
            res.data.time &&
            res.data.time.length > 0
          ) {
            const datas = res.data;
            this[timeType] = datas.timestamp.map((it) => {
              return this.$formatDate(new Date(it), "MM-dd hh时");
            });
            this[type].map((item) => {
              datas.sensor.some((it) => {
                if (it.hd_device_sensor_channel == item.channel) {
                  item.echartsData = it.data ? it.data : it.avg_data;
                  item.indexs = it.index;
                  return true;
                }
              });
              return item;
            });
            console.log("数据sss", this.qxzList);
            this.$refs.echarts.setOptions(this.getOptions());
          }
        })
        .catch(() => {
          this.$refs.echarts.noOption();
        });
    },
    getOptions() {
      // let data = this.qxzList[this.isChoose];
      let lengs = [],
        yAxisData1 = [],
        yAxisData2 = [],
        yAxisData3 = [],
        yAxisData4 = [],
        yAxisData5 = [],
        yAxisData6 = [];
      this.qxzList.map((item) => {
        if (item.name.indexOf("温") > -1) {
          item.echartsData.map((ele, idx) => {
            yAxisData1.push([item.indexs[idx], item.echartsData[idx]]);
          });
          lengs.push("温度");
        } else if (item.name.indexOf("湿") > -1) {
          item.echartsData.map((ele, idx) => {
            yAxisData2.push([item.indexs[idx], item.echartsData[idx]]);
          });
          lengs.push("湿度");
        } else if (item.name.indexOf("向") > -1) {
          item.echartsData.map((ele, idx) => {
            yAxisData3.push([item.indexs[idx], item.echartsData[idx]]);
          });
          lengs.push("风向");
        } else if (item.name.indexOf("速") > -1) {
          item.echartsData.map((ele, idx) => {
            yAxisData4.push([item.indexs[idx], item.echartsData[idx]]);
          });
          lengs.push("风速");
        } else if (item.name.indexOf("压") > -1) {
          item.echartsData.map((ele, idx) => {
            yAxisData5.push([item.indexs[idx], item.echartsData[idx]]);
          });
          lengs.push("气压");
        } else if (item.name.indexOf("量") > -1) {
          item.echartsData.map((ele, idx) => {
            yAxisData6.push([item.indexs[idx], item.echartsData[idx]]);
          });
          lengs.push("雨量");
        }
      });
      return {
        color: "#0090FF",
        legend: {
          data: lengs,
          right: 10,
          textStyle: {
            color: "#fff",
          },
          selectedMode: "single",
        },
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: 35,
          right: 25,
          left: 25,
          bottom: 20,
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            axisTick: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            axisLabel: {
              color: "#fff",
            },
            data: this.equimentTimes,
          },
        ],
        yAxis: [
          {
            type: "value",
            // name: "°C",
            axisLabel: {
              textStyle: {
                color: "#fff",
              },
            },
            nameTextStyle: {
              color: "#fff",
            },
            splitLine: {
              lineStyle: {
                color: "rgba(0, 144, 255,0.3)",
              },
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            axisTick: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: "温度",
            type: "line",
            smooth: true,
            showSymbol: false,
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(0, 144, 255, 0.3)",
                    },
                    {
                      offset: 1,
                      color: "rgba(0, 144, 255,0.1)",
                    },
                  ],
                  false
                ),
                shadowColor: "rgba(0, 144, 255,0.1)",
                shadowBlur: 10,
              },
            },
            data: yAxisData1,
          },
          {
            name: "湿度",
            type: "line",
            smooth: true,
            showSymbol: false,
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(0, 144, 255, 0.3)",
                    },
                    {
                      offset: 1,
                      color: "rgba(0, 144, 255,0.1)",
                    },
                  ],
                  false
                ),
                shadowColor: "rgba(0, 144, 255,0.1)",
                shadowBlur: 10,
              },
            },
            data: yAxisData2,
          },
          {
            name: "风向",
            type: "line",
            smooth: true,
            showSymbol: false,
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(0, 144, 255, 0.3)",
                    },
                    {
                      offset: 1,
                      color: "rgba(0, 144, 255,0.1)",
                    },
                  ],
                  false
                ),
                shadowColor: "rgba(0, 144, 255,0.1)",
                shadowBlur: 10,
              },
            },
            data: yAxisData3,
          },
          {
            name: "风速",
            type: "line",
            smooth: true,
            showSymbol: false,
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(0, 144, 255, 0.3)",
                    },
                    {
                      offset: 1,
                      color: "rgba(0, 144, 255,0.1)",
                    },
                  ],
                  false
                ),
                shadowColor: "rgba(0, 144, 255,0.1)",
                shadowBlur: 10,
              },
            },
            data: yAxisData4,
          },
          {
            name: "气压",
            type: "line",
            smooth: true,
            showSymbol: false,
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(0, 144, 255, 0.3)",
                    },
                    {
                      offset: 1,
                      color: "rgba(0, 144, 255,0.1)",
                    },
                  ],
                  false
                ),
                shadowColor: "rgba(0, 144, 255,0.1)",
                shadowBlur: 10,
              },
            },
            data: yAxisData5,
          },
          {
            name: "雨量",
            type: "line",
            smooth: true,
            showSymbol: false,
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(0, 144, 255, 0.3)",
                    },
                    {
                      offset: 1,
                      color: "rgba(0, 144, 255,0.1)",
                    },
                  ],
                  false
                ),
                shadowColor: "rgba(0, 144, 255,0.1)",
                shadowBlur: 10,
              },
            },
            data: yAxisData6,
          },
        ],
      };
    },
  },
};
</script>

<style lang="stylus" scoped>
.flex
  display flex

.cardContentT
  height 100%
  .chart
    position relative
    height 100%
.choseType
  margin 0 10px
  font-size 13px
  cursor pointer
  border-bottom 2px solid transparent
  color #00e2fb
.select
  color #ffd400
  border-bottom 2px solid
</style>
